import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  pageNumber: 1,
  rowsPerPage: 5,
};

const rcAutoPaginationSlice = createSlice({
  name: "rcAutoPagination",
  initialState,
  reducers: {
    setRcAutoPageNumber: (state, action) => {
      state.pageNumber = action.payload;
    },
    setRcAutoRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setRcAutoPagination: (state, action) => {
      state.pageNumber = action.payload.pageNumber || state.pageNumber;
      state.rowsPerPage = action.payload.rowsPerPage || state.rowsPerPage;
    },
    resetRcAutoPagination: (state) => {
      state.pageNumber = 1;
      state.rowsPerPage = 5;
    },
  },
});

export const {
  setRcAutoPageNumber,
  setRcAutoRowsPerPage,
  setRcAutoPagination,
  resetRcAutoPagination,
} = rcAutoPaginationSlice.actions;
export default rcAutoPaginationSlice.reducer;
